module.exports = __webpack_public_path__ + "static/img/lichengImg.160be12d.png";